import React from 'react';
import { CountryFlag } from '@fourthwall/components';
import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase';
import { createStatsData } from '../../utils/createStatsData';
const reportId = 'sales_by_country';
export const useSalesByCountryReportCard = () => {
    const analyticsCardBase = useAnalyticsCardBase({ reportId });
    const data = createStatsData({
        rows: analyticsCardBase.reportData?.report?.rows,
        mapFn: (row) => ({
            label: React.createElement(CountryFlag, { countryCode: row.country }),
            value: row.income.value,
        }),
    });
    return {
        ...analyticsCardBase,
        type: 'stats',
        data,
    };
};
